/** @format */

import * as shajs from 'sha.js';

import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input,
	OnChanges,
	AfterViewInit,
	SimpleChanges,
	SimpleChange,
	AfterContentInit,
	AfterViewChecked,
	ChangeDetectorRef,
} from '@angular/core';
import {
	ImageFile,
	ImageFilePayload,
	ImageFileUploadErrorMapping,
	PhotoUploadErrorType,
	QuestionAnswer,
	QuestionConfirmationStatus,
	QuestionTypes,
} from 'src/app/store/application';
import { isMobile } from 'src/assets/isMobileChecker';
import * as jQuery from 'jquery';
const reduce = require('image-blob-reduce')();

@Component({
	selector: 'app-details-entry',
	templateUrl: './details-entry.component.html',
	styleUrls: ['./details-entry.component.scss'],
})
export class DetailsEntryComponent implements OnInit, OnChanges, AfterContentInit, AfterViewChecked {
	@Input() detailsText: string;
	@Input() photoList: ImageFile[];
	@Input() shouldTriggerReRender: boolean;
	@Input() problemRelatedQuestions: QuestionAnswer[];
	@Input() isErrorPresentOnPage: boolean;
	@Output() problemDetails = new EventEmitter<string>();
	@Output() addPhoto = new EventEmitter<ImageFilePayload>();
	@Output() removePhoto = new EventEmitter<string>();
	@Output() setAnsweredProblemQuestions = new EventEmitter<QuestionAnswer[]>();
	@Output() resetTriggerReRender = new EventEmitter();

	readonly MAX_NUM_CHARACTERS_ALLOWED = 2000;
	readonly MAX_NUM_PHOTOS_ALLOWED = 5;
	readonly KB_TO_MB_CONVERSION_RATE = 0.000001;
	readonly B_TO_MB_DIVISION_CONVERSION_RATE = 1048576;
	readonly MB_ALLOWED_FILE_SIZE = 4;

	detailsTextEntry = '';
	remainingCharactersAvailable = this.MAX_NUM_CHARACTERS_ALLOWED;
	problemQuestions: QuestionAnswer[] = [];
	findSelectInterval: any;
	inputLoadedTimer: any;
	cameraInputTimer: any;
	selectLoaded: boolean = false;
	rejectionIntervalTimer: any;
	questionHeading: string = '';
	isVehicleQuestion = false;

	// isQuestionAnswerRequired = false;

	errorMessageIntervalTimer: any;

	imageUploadErrors: ImageFileUploadErrorMapping[] = [];
	errorsDetectedStrings: string[] = [];

	isMobile = isMobile;

	constructor() {}

	ngOnInit(): void {
		this.inputLoadedTimer = setInterval(() => {
			if (document.getElementById('fileSelectionInput')) {
				document.getElementById('fileSelectionInput')?.addEventListener('change', (event: any) => {
					this.handleFileExtraction(event);
				});

				clearInterval(this.inputLoadedTimer);
			}
		}, 100);

		document.addEventListener('drop', (event: any) => {
			event.preventDefault();
			this.itemDragEndHandler();
		});

		if (this.isMobile.any()) {
			this.cameraInputTimer = setInterval(() => {
				if (document.getElementById('openCameraInput')) {
					document.getElementById('openCameraInput')?.addEventListener('change', (event: any) => {
						this.handleFileExtraction(event);
					});

					clearInterval(this.cameraInputTimer);
				}
			}, 100);
		}

		setInterval(() => {
			if (this.photoList && this.photoList.some((photo) => photo.imageStatus === 'uploading')) {
				this.photoList
					.filter((photo) => photo.imageStatus === 'uploading')
					.forEach((photo) => {
						this.updateProgressBar(photo);
					});
			}
		}, 100);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.detailsText.length > 0) {
			this.detailsTextEntry = this.detailsText;
			this.remainingCharactersAvailable = this.MAX_NUM_CHARACTERS_ALLOWED - this.detailsTextEntry.length;
		}

		if (this.problemRelatedQuestions.length > 0) {
			this.problemQuestions = jQuery.extend(true, [], this.problemRelatedQuestions);
			// this.isQuestionAnswerRequired = this.problemQuestions.some(question => question.isRequired);

			let selectExists = this.problemQuestions.some((problemQuestion) => !!problemQuestion.selectOptions);
			if (selectExists && !this.selectLoaded) {
				this.findSelectInterval = setInterval(() => {
					if (document.querySelectorAll('select').length) {
						this.selectLoaded = true;
						document.querySelectorAll('select').forEach((selectElement) => (selectElement.selectedIndex = 0));
						clearInterval(this.findSelectInterval);
					}
				}, 100);
			}

			this.questionHeading = this.problemRelatedQuestions[0].questionHeading || '';
			this.isVehicleQuestion = this.problemRelatedQuestions.some((question) => question.question.toLowerCase().includes('vehicle'));
		}

		this.resetAndCheckErrorText();

		// run this code only if there are problem questions as the description is managed by the html conditional blocks
		if (this.problemQuestions.length) {
			this.problemQuestions.forEach(
				(question) =>
					(question.shouldDisplayNotFilledError =
						this.isErrorPresentOnPage &&
						question.isRequired &&
						question.questionViewable &&
						!this.isJustNowViewableQuestion(question, changes) &&
						((question.questionType === QuestionTypes.RadioButton &&
							question.radioOptions?.includes('Other') &&
							question.answer === 'Other' &&
							question.radioOtherOptionEntry?.length === 0) ||
							(question.checkOptionAnswers && !question.checkOptionAnswers.some((checkAnswer) => checkAnswer.answer)) ||
							(question.questionType === QuestionTypes.ConfirmationToggle && !question.confirmationAnswer) ||
							(question.questionType !== QuestionTypes.Checkbox &&
								question.questionType !== QuestionTypes.ConfirmationToggle &&
								(question.answer as string).length === 0)))
			);
		}

		if (this.isErrorPresentOnPage) {
			if (!this.problemQuestions.length || !this.problemQuestions.some((question) => question.isRequired)) {
				document.getElementsByClassName('textEntryInfo')[0].scrollIntoView({ behavior: 'smooth' });
			} else {
				document.getElementsByClassName('problemQuestionAnswer')[0].scrollIntoView({ behavior: 'smooth' });
			}
		}
	}

	isJustNowViewableQuestion(question: QuestionAnswer, changes: SimpleChanges): boolean {
		let isJustNowViewable = false;
		if (changes.problemRelatedQuestions) {
			// check question number - 1 since the questionNumber variable starts from 1 instead of 0
			let questionIndexNum = question.questionNumber - 1;
			let previousQuestionValue = changes.problemRelatedQuestions.previousValue[questionIndexNum];

			if (!previousQuestionValue.questionViewable && question.questionViewable) {
				isJustNowViewable = true;
			}
		}

		return isJustNowViewable;
	}

	ngAfterContentInit(): void {
		if (this.isMobile.any()) {
			document.getElementById('attachPhotoContainer')?.classList.add('bigDisplayOnly');
		}
	}

	ngAfterViewChecked(): void {
		if (this.shouldTriggerReRender) {
			this.resetTriggerReRender.emit();
		}
	}

	resetAndCheckErrorText() {
		this.errorsDetectedStrings = [];
		this.setUploadErrorMsg(PhotoUploadErrorType.ClearErrorText);
		this.clearPhotoUploadErrorUI();

		if (this.imageUploadErrors.length > 0) {
			this.imageUploadErrors.forEach((imageError) => this.setUploadErrorMsg(imageError.errorType));
		}
	}

	addToPhotoErrorMapper(hash: string, errorType: PhotoUploadErrorType) {
		if (!this.imageUploadErrors.some((image) => image.hash === hash)) {
			this.imageUploadErrors.push({ hash, errorType });
		} else {
			let index = this.imageUploadErrors.findIndex((image) => image.hash === hash);
			this.imageUploadErrors[index].errorType = errorType;
		}
	}

	updateProgressBar(photo: ImageFile) {
		let findProgressBarInterval = setInterval(() => {
			let photoHash = photo.hash;
			let progressBar = document.getElementById(photoHash);

			if (!!progressBar) {
				clearInterval(findProgressBarInterval);
				let currentWidth = parseInt(progressBar?.style.width! || '0');

				for (let i = currentWidth; i <= photo.progress; i++) {
					progressBar?.setAttribute('style', `width:${photo.progress}%`);
				}
			} else {
				if (photo.imageStatus !== 'uploading') {
					clearInterval(findProgressBarInterval);

					if (photo.imageStatus === 'rejected') {
						// let filesUnderSizeLimit = true;

						let file = photo.file;
						// filesUnderSizeLimit = filesUnderSizeLimit && this.isFileSizeAllowed(file);
						// if (!filesUnderSizeLimit) {
						//   this.setUploadErrorMsg(PhotoUploadErrorType.FileSizeTooBig);
						//   this.addToPhotoErrorMapper(photo.hash, PhotoUploadErrorType.FileSizeTooBig);
						//   return;
						// }

						const fileReader = new FileReader();
						fileReader.readAsDataURL(file);
						fileReader.onload = (event: any) => {
							//Initiate the JavaScript Image object.
							var image = new Image();
							image.src = event.target.result;

							//Validate the File Height and Width.
							image.onload = (img: any) => {
								var height = img.target.height;
								var width = img.target.width;

								if (height < 50 || width < 50) {
									this.setUploadErrorMsg(PhotoUploadErrorType.ImageDimensionsTooSmall);
									this.addToPhotoErrorMapper(photo.hash, PhotoUploadErrorType.ImageDimensionsTooSmall);
									return;
								} else {
									this.setUploadErrorMsg(PhotoUploadErrorType.PhotoUploadRejected);
									this.addToPhotoErrorMapper(photo.hash, PhotoUploadErrorType.PhotoUploadRejected);
									return;
								}
							};
						};
					}
				}
			}
		}, 100);
	}

	getUploadErrorMessage(photoFile: ImageFile) {
		let errorItem = this.imageUploadErrors.find((imageError) => imageError.hash === photoFile.hash);
		switch (errorItem?.errorType) {
			case PhotoUploadErrorType.FileSizeTooBig:
				return `File too large`;

			case PhotoUploadErrorType.ImageDimensionsTooSmall:
				return `Image too small`;

			default:
				return `Upload unsuccessful`;
		}
	}

	addToErrorStringArray(errorString: string) {
		if (!this.errorsDetectedStrings.some((detectedErrorString) => detectedErrorString === errorString)) {
			this.errorsDetectedStrings.push(errorString);
		}
	}

	setUploadErrorMsg(photoUploadErrorType: PhotoUploadErrorType) {
		let msg = '';

		switch (photoUploadErrorType) {
			case PhotoUploadErrorType.IncorrectFileType:
				// msg = 'Only the listed file types are supported. Please try again.';
				this.addToErrorStringArray('File type not supported. Upload one of the following types and try again: jpg, jpeg, png.');
				break;

			case PhotoUploadErrorType.PhotoUploadRejected:
				// msg = 'One or more of your photos did not successfully upload. Please try again.'
				this.addToErrorStringArray('One or more of your photos did not successfully upload. Please try again.');
				break;

			case PhotoUploadErrorType.UploadLimitMet:
				// msg = 'You have reached the maximum number of photos you can upload.';
				this.addToErrorStringArray(
					`A maximum number of ${this.MAX_NUM_PHOTOS_ALLOWED} photos has been reached. Remove an uploaded photo and try again.`
				);
				break;

			case PhotoUploadErrorType.TooManyPhotosSelected:
				// msg = `The number of photos selected exceeds the maximum limit of ${this.MAX_NUM_PHOTOS_ALLOWED} photos.`;
				this.addToErrorStringArray(
					`The number of selected photos exceeds the maximum limit of ${this.MAX_NUM_PHOTOS_ALLOWED}. Please try again.`
				);
				break;

			case PhotoUploadErrorType.FileSizeTooBig:
				// msg = `The files included contain sizes greater than the maximum alloted ${this.MB_ALLOWED_FILE_SIZE}MB max individual file size. Please try again.`;
				this.addToErrorStringArray(`One or more of your photos exceeded ${this.MB_ALLOWED_FILE_SIZE}MB. Reduce the file size and try again.`);
				break;

			case PhotoUploadErrorType.ImageDimensionsTooSmall:
				// msg = `The files included do not meet the minimum height and width dimension requirements of 50px x 50px. Please try again.`;
				this.addToErrorStringArray(
					`The files included do not meet the minimum height and width dimension requirements of 50px x 50px. Please try again.`
				);
				break;

			case PhotoUploadErrorType.ClearErrorText:
				msg = '';
				break;
		}

		if (this.errorsDetectedStrings.length > 0) {
			this.displayPhotoUploadErrorUI();
			this.errorsDetectedStrings.forEach((errorString) => {
				msg += `${errorString}<br>`;

				if (isMobile.any()) {
					msg += '<br>';
				}
			});

			// remove the last copy of the <br> statement
			if (isMobile.any()) {
				let lastIndexOfBr = msg.lastIndexOf('<br>');
				msg = msg.slice(0, lastIndexOfBr);
			}
		} else {
			this.clearPhotoUploadErrorUI();
		}

		if (document.getElementById('photoUploadErrorMessage')) {
			(document.getElementById('photoUploadErrorMessage') as any).innerHTML = msg;
		}
	}

	handleFileExtraction(event: any) {
		const fileList = event.target.files;
		let files: File[] = [];

		for (let i = 0; i < fileList.length; i++) {
			files.push(fileList.item(i)!);
		}

		this.handleAddPhotos(files);
		event.target.value = '';
	}

	getRadioName(question: QuestionAnswer) {
		return question.question.replace(/\s/g, '');
	}

	checkShouldAlignHorizontal(problemQuestion: QuestionAnswer) {
		let shouldAlignHorizontal =
			problemQuestion.radioOptions &&
			problemQuestion.radioOptions.length === 2 &&
			!(problemQuestion.conditionalYesMsg || problemQuestion.conditionalNoMsg) &&
			!problemQuestion.radioOptions.some((option) => option === 'Yes' || option === 'No');

		return shouldAlignHorizontal;
	}

	shouldDisplayConditionalResponse(problemQuestion: QuestionAnswer) {
		return (
			problemQuestion.answer !== '' &&
			((problemQuestion.answer === 'Yes' && problemQuestion.conditionalYesMsg) ||
				(problemQuestion.answer === 'No' && problemQuestion.conditionalNoMsg))
		);
	}

	shouldDisplayTextAsRed(problemQuestion: QuestionAnswer) {
		return (
			this.problemQuestions.some(
				(problemQuestion) => problemQuestion.question === 'Was the cart stickered?' && problemQuestion.answer === 'Yes'
			) &&
			problemQuestion.question === 'Have you remedied the issue?' &&
			problemQuestion.answer === 'No'
		);
	}

	updateEntry() {
		this.remainingCharactersAvailable = this.MAX_NUM_CHARACTERS_ALLOWED - this.detailsTextEntry.length;
		this.problemDetails.emit(this.detailsTextEntry);
	}

	updateAnswer() {
		let answerMap: Map<number, string> = new Map();
		this.problemQuestions.forEach((question) => {
			if (!question.dependsOnQuestionAnswer || question.questionViewable) {
				answerMap.set(question.questionNumber, question.answer);
			}
		});

		this.problemQuestions.forEach((question) => {
			if (question.dependsOnQuestionAnswer) {
				let isQuestionViewable = false;
				for (let [key, requiredAnswer] of question.dependsOnQuestionAnswer) {
					// check if a key exists and if so, check for a matching answer
					if (answerMap.has(key)) {
						let answer = answerMap.get(key);
						if (answer === requiredAnswer) {
							isQuestionViewable = true;
						}
					}
				}

				question.questionViewable = isQuestionViewable;
				question.answer = isQuestionViewable ? question.answer : '';

				if (question.questionType === QuestionTypes.ConfirmationToggle) {
					question.confirmationStatus = question.confirmationAnswer
						? QuestionConfirmationStatus.Confirmed
						: QuestionConfirmationStatus.Unconfirmed;
				}
			}

			if (question.questionType === QuestionTypes.RadioButton && question.radioOptions?.includes('Other') && question.answer !== 'Other') {
				question.radioOtherOptionEntry = '';
			}
		});

		this.setAnsweredProblemQuestions.emit(this.problemQuestions);
	}

	trackByFn(index: any, item: any) {
		return index;
	}

	openCamera() {
		document.getElementById('openCameraInput')?.click();
	}

	openFileSelectionDialog() {
		if (this.photoList.length !== this.MAX_NUM_PHOTOS_ALLOWED) {
			document.getElementById('fileSelectionInput')?.click();
		} else {
			this.setUploadErrorMsg(PhotoUploadErrorType.UploadLimitMet);
		}
	}

	isFileTypeImage = (file: File) => !!file.type.match('image.png|image.jpg|image.jpeg');

	isFileSizeAllowed = (file: File) => parseFloat((file.size / this.B_TO_MB_DIVISION_CONVERSION_RATE).toFixed(4)) <= this.MB_ALLOWED_FILE_SIZE;

	displayPhotoUploadErrorUI() {
		document.getElementById('attachPhotoContainer')?.classList.add('attachPhotoError');
		document.getElementById('attachPhotoContainerMobile')?.classList.add('attachPhotoError');
	}

	clearPhotoUploadErrorUI() {
		document.getElementById('attachPhotoContainer')?.classList.remove('attachPhotoError');
		document.getElementById('attachPhotoContainerMobile')?.classList.remove('attachPhotoError');
	}

	handleAddPhotos(files: File[]) {
		this.resetAndCheckErrorText();

		let filesCorrectType = true;
		files.forEach((file) => (filesCorrectType = filesCorrectType && this.isFileTypeImage(file)));
		if (!filesCorrectType) {
			this.setUploadErrorMsg(PhotoUploadErrorType.IncorrectFileType);
			return;
		}

		if (files.length + this.photoList.length > this.MAX_NUM_PHOTOS_ALLOWED) {
			this.setUploadErrorMsg(PhotoUploadErrorType.TooManyPhotosSelected);
			return;
		}

		files.forEach((file) => {
			const fileReader = new FileReader();

			fileReader.onload = (event: any) => {
				if (file.size / 1000 > 4000) {
					reduce.toBlob(file, { max: 2000 }).then((blob: any) => {
						this.blobToBase64(blob).then((base64) => {
							this.addPhoto.emit({ file: file, event: base64 });
						});
					});
				} else {
					this.addPhoto.emit({ file, event: event.target.result });
				}
			};

			fileReader.readAsDataURL(file);
			// TODO this works but fileReader.readAsDataURL is non blocking
			// and since we immediately exit the context where fileReader is declared,
			// it could be reclamed before emiting 'onload'
			// see for alternative https://stackoverflow.com/questions/70035179/readasdataurl-async-await
		});
	}

	getFileSize(kiloByteSize: number) {
		let megaByteSize = kiloByteSize * this.KB_TO_MB_CONVERSION_RATE;
		let size = `${megaByteSize.toFixed(1)}MB`;
		return size;
	}

	getPhotoList(setNumber: number) {
		let numPhotos = this.photoList.length;

		switch (setNumber) {
			case 1:
				if (numPhotos > 3) {
					return this.photoList.slice(0, 3);
				}

				return this.photoList.slice(0, numPhotos);

			case 2:
				if (numPhotos > 3) {
					return this.photoList.slice(3);
				}
		}

		return [];
	}

	handlePhotoRemoval(hash: string) {
		this.removePhoto.emit(hash);
		this.imageUploadErrors = this.imageUploadErrors.filter((errorMapping) => errorMapping.hash !== hash);
	}

	itemDropHandler(event: any) {
		let files: File[] = [];

		// Prevent default behavior (Prevent file from being opened)
		event.preventDefault();
		if (event.dataTransfer.items) {
			// Use DataTransferItemList interface to access the file(s)
			for (var i = 0; i < event.dataTransfer.items.length; i++) {
				// If dropped items aren't files, reject them
				if (event.dataTransfer.items[i].kind === 'file') {
					let file = event.dataTransfer.items[i].getAsFile();
					files.push(file);
				}
			}
		} else {
			// Use DataTransfer interface to access the file(s)
			for (var i = 0; i < event.dataTransfer.files.length; i++) {
				let file = event.dataTransfer.files.item(i);
				files.push(file);
			}
		}

		this.handleAddPhotos(files);
		this.itemDragEndHandler();
	}

	itemDragOverHandler(event: any) {
		// Prevent default behavior (Prevent file from being opened)
		event.preventDefault();
		document.getElementsByClassName('attachPhotoContainer')[0].classList.add('dragging');
	}

	itemDragEndHandler() {
		document.getElementsByClassName('attachPhotoContainer')[0].classList.remove('dragging');
	}

	blobToBase64(blob: any) {
		return new Promise((resolve, _) => {
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = () => resolve(reader.result);
		});
	}
}
